export enum DrillModeEnum {
  ACTIVE = 'ACTIVE',
  DEACTIVATE = 'DEACTIVATE'
}
